module.exports = __webpack_public_path__ + "static/media/newProjectActive.511999fa.svg";